import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { getSubTotal } from 'rootReducer'
import { FormattedMessage } from 'react-intl'
import {isEmpty} from "utils";
import messages from "./messages";

const Flexer = styled.div`
    margin-top: 148px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
`;
const Check = styled.div`
    &:before {
        content: "k";
        font-family: "bbyc-crm-covert-app-icon-fonts" !important;
        font-size: 70px;
        color: #0046BE;
    }
    text-align: center;
`;
const Title = styled.p`
    color: #333333;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
`;
const SubTitle = styled.p`
    color: rgba(0, 0, 0, 0.87);
    font-size: 13px;
    line-height: 18px;
    text-align: center;
`;
class OrderComplete extends PureComponent {
    static propTypes = {
        subTotal: PropTypes.number,
    };
    render() {
        const {subTotal} = this.props;
        const title = subTotal ? messages.titleNoProgram : messages.titleEntitlement;
        const subTitle = subTotal ? messages.subTitleNoProgram : messages.subTitleEntitlement;
        return (
            <Flexer>
                <Check />
                <Title>
                    <FormattedMessage {...title} />
                </Title>
                <SubTitle>
                    <FormattedMessage {...subTitle} />
                </SubTitle>
            </Flexer>
        );
    }
}

const mapStateToProps = state => ({
  subTotal: getSubTotal(state),
})

export const OrderCompleteContainer = connect(mapStateToProps)(OrderComplete)



// WEBPACK FOOTER //
// ./src/containers/Cart/OrderComplete/OrderCompleteContainer.js